import { createSlice } from '@reduxjs/toolkit';

import { ICheckout } from '../../../core/interfaces/ICheckout';
import { CheckoutReducer } from '../../reducers/CheckoutReducer';

const initialState: ICheckout = {
	insurance_name: '',
	plan: '',
	currency: 'BRL',
	currency_symbol: 'R$',
	start_date: '',
	end_date: '',
	max_warranty_limit: '',
	signer_type: '',
	signer_email: '',
	signer_name: '',
	admin_email: '',
	admin_name: '',
	gross_premium: '',
	iof: '',
	interest: '',
	total_premium: '',
	installments: '',
	insurer_name: '',
	is_loading_payment_section: false,
};

export const checkoutSlice = createSlice({
	name: 'checkout',
	initialState,
	reducers: CheckoutReducer,
});

export const {
	initCheckout,
	toggleLoadingPaymentSection,
	setPaymentSummary,
	setStartDateAndEndDate,
	setSignerName,
	setSignerEmail,
	setSignerType,
	setMaxLimitWarranty,
	setInsuranceName,
	setInsurerName,
	setAdminName,
	setAdminEmail,
} = checkoutSlice.actions;

export default checkoutSlice.reducer;
